module.exports = __webpack_public_path__ + "static/media/EditBlue.296f7633.svg";